import type { DocEntityBase } from "building-types/entities/docEntityBase";
import { sortEntitiesBySortIndex } from "common/utils/sortIndex";
import type { DocEntityGetChildrenParams } from "./docEntityGetChildren";
import docEntityGetChildren from "./docEntityGetChildren";
import docGetEntity from "./docGetEntity";

export function docEntityGetChildrenEntities<T extends DocEntityBase>(...args: DocEntityGetChildrenParams): T[] {
  const handles = docEntityGetChildren(...args);
  return handles.map((handle) => docGetEntity(args[0], handle)) as T[];
}

export function docEntityGetSortedChildrenEntities<T extends DocEntityBase>(...args: DocEntityGetChildrenParams): T[] {
  const children = docEntityGetChildrenEntities(...args);
  return sortEntitiesBySortIndex(children).filter((child) => child !== undefined) as T[];
}
